import styled, { css } from 'styled-components';
import {
  borderShape,
  backgroundShape,
  mq,
  px2rem,
  getFixedSpace
} from '../../../stylesheets/tools';

const StyledFilter = styled.div`
  position: relative;
  z-index: 2;
  mix-blend-mode: multiply;

  .filter__list {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;

    ${mq('m')} {
      width: 100%;
    }
  }

  .filter__list-wrapper {
    align-items: center;
    display: inline-flex;
    justify-content: flex-start;
    margin: 0 ${getFixedSpace('xxxl')};

    ${mq('m')} {
      display: flex;
      justify-content: center;
    }
  }

  /* Filter label is needed for accessibility reasons */
  .filter__label {
    display: block;
    width: 100%;
    text-align: center;
    margin: ${getFixedSpace('xs')} 0;
  }

  .filter__item {
    position: relative;
    z-index: 3;
    margin: 7px;

    ${props =>
      props.isLoading &&
      css`
        opacity: 0.6;
        pointer-events: none;
      `}
  }

  .filter__name {
    cursor: pointer;
    display: flex;
    align-items: center;
    position: relative;
    padding: 10px ${getFixedSpace('xxs')};
    line-height: 22px;
    font-size: 20px;
    text-transform: uppercase;
    ${borderShape()}

    ${mq('m')} {
      line-height: 22px;
      font-size: 22px;
    }

    &:last-of-type {
      margin-right: 0;
    }

    &:hover {
      color: #fff;
      ${backgroundShape()};
    }

    svg {
      width: 16px;
      height: 16px;
      margin-left: 10px;
      fill: #fff;
    }
  }

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  input:checked ~ .filter__name {
    color: #fff;
    ${backgroundShape()};
  }

  input:focus ~ .filter__name {
    ${backgroundShape('black')};
    color: #fff;
  }

  ${props =>
    props.hasMargin &&
    css`
      margin-top: ${px2rem('150px')};
    `}

  ${props =>
    props.insideHeader &&
    css`
      flex-grow: 2;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      order: 1;
      width: 100%;
      border-top: 2px solid rgba(255, 255, 255, 0.3);
      mix-blend-mode: normal;

      ${mq('xl')} {
        order: 0;
        margin: 0 ${getFixedSpace('l')};
        border-top: none;
        border-left: 2px solid rgba(255, 255, 255, 0.3);
      }

      .filter__wrapper {
        width: 100%;
        display: inline-flex;
        align-items: center;
        padding: ${getFixedSpace('xxs')};
        white-space: nowrap;

        ${mq('xl')} {
          padding: 0 0 0 ${getFixedSpace('m')};
          overflow-y: visible;
        }
      }

      .filter__label {
        display: inline-block;
        width: auto;
        margin: 0;
        font-size: 16px;
        margin-right: ${getFixedSpace('xs')};
      }

      .filter__list {
        display: inline-block;
        width: auto;
        overflow-y: visible;
      }

      .filter__list-wrapper {
        margin: 0;

        ${mq('xl')} {
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
          justify-content: flex-start;
        }
      }

      .filter__item {
        margin: 0 7px;
      }

      .filter__name {
        padding: 7px 11px;
        ${borderShape('#fff')}

        &:hover {
          color: #000;
          ${backgroundShape('#fff')};
        }

        svg path,
        svg g,
        svg rect {
          fill: ${props.theme.globalTheme.primary} !important;
        }
      }

      input:checked ~ .filter__name {
        color: #000;
        ${backgroundShape('#fff')};
      }

      input:focus ~ .filter__name {
        color: #000;
        ${backgroundShape('#fff')};
      }
    `}
`;

export default StyledFilter;
